import React from 'react';
import { Modal as OldModal } from 'sema-ui-components';
import styles from './Modal.scss';

export const Modal = props => (
  <OldModal {...props} className={styles.container} />
);
